/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * Utility to paginate an array of items.
 * @param items - The array of items to paginate.
 * @param activeIndex - The current page index (0-based).
 * @param perPage - The desired number of items per page, can be a string or number.
 * @returns An object containing pagination details and the paginated data.
 */
export function paginator<T>({
    items,
    activeIndex = 0,
    perPage = 10,
}: {
    items: T[];
    activeIndex: number;
    perPage: string | number; // string allows easier integration with Select
}) {
    const perPageNum = typeof perPage === 'string' ? parseInt(perPage, 10) : perPage;
    const offset = activeIndex * perPageNum;

    const paginatedData = items.slice(offset).slice(0, perPageNum);
    const totalPages = Math.ceil(items.length / perPageNum);

    return {
        activeIndex,
        perPage,
        totalPages,
        totalItems: items.length,
        previousPage: activeIndex ? activeIndex - 1 : null,
        nextPage: totalPages >= activeIndex + 1 ? activeIndex + 1 : null,
        paginatedData,
        offset,
        firstVisible: offset + 1,
        lastVisible: offset + 1 + perPageNum,
    };
}
